import React from "react";

const ApplicationFooter: React.FunctionComponent = (props) => {
    return <div className="bottom-footer">
        {props.children}
    </div>
}

export default ApplicationFooter;